// Reel & BTS content.
export const reels = [
  {
    id: "reel-267282773",
    title: "Selected Work I",
    role: "Cinematographer",
    year: "—",
    format: "Film",
    runtime: "—",
    poster:
      "https://images.unsplash.com/photo-1521794286957-348245b517a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBuaWdodCUyMHNob3R8ZW58MHx8fHwxNzgyNjkwOTcxfDA&ixlib=rb-4.1.0&q=85",
    embed: "https://player.vimeo.com/video/267282773",
    sourceUrl: "https://vimeo.com/267282773",
    summary:
      "A patient, image-led piece. Shot, framed and graded for emotional pacing — let the frame breathe.",
  },
  {
    id: "reel-143125292",
    title: "Selected Work II",
    role: "Cinematographer",
    year: "—",
    format: "Film",
    runtime: "—",
    poster:
      "https://images.unsplash.com/photo-1616749328467-9af5031949a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBuaWdodCUyMHNob3R8ZW58MHx8fHwxNzgyNjkwOTcxfDA&ixlib=rb-4.1.0&q=85",
    embed: "https://player.vimeo.com/video/143125292",
    sourceUrl: "https://vimeo.com/143125292",
    summary:
      "Available-light photography with a quiet, observational eye. Composition first, lighting second.",
  },
  {
    id: "reel-99383593",
    title: "Selected Work III",
    role: "Cinematographer",
    year: "—",
    format: "Film",
    runtime: "—",
    poster:
      "https://images.unsplash.com/photo-1554103577-c0d26e9b90e0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBuaWdodCUyMHNob3R8ZW58MHx8fHwxNzgyNjkwOTcxfDA&ixlib=rb-4.1.0&q=85",
    embed: "https://player.vimeo.com/video/99383593",
    sourceUrl: "https://vimeo.com/99383593",
    summary:
      "Texture and mood study. Long takes, soft motion, deliberate negative space.",
  },
];

export const btsItems = [
  {
    id: "bts-1",
    src: "https://customer-assets.emergentagent.com/job_video-showcase-354/artifacts/foum4r9r_IMG_5387.jpeg",
    caption: "Director & DP · rig handoff",
    aspect: "aspect-square",
  },
  {
    id: "bts-2",
    src: "https://customer-assets.emergentagent.com/job_video-showcase-354/artifacts/gqwo1iga_IMG_5385.jpeg",
    caption: "Village monitor · T + 00:28",
    aspect: "aspect-square",
  },
  {
    id: "bts-3",
    src: "https://customer-assets.emergentagent.com/job_video-showcase-354/artifacts/obt0o87l_IMG_5384.jpeg",
    caption: "Fighter · rim light from stage right",
    aspect: "aspect-square",
  },
  {
    id: "bts-4",
    src: "https://customer-assets.emergentagent.com/job_video-showcase-354/artifacts/gnmcbctu_IMG_5383.jpeg",
    caption: "Stairwell setup · block-through",
    aspect: "aspect-square",
  },
  {
    id: "bts-5",
    src: "https://customer-assets.emergentagent.com/job_video-showcase-354/artifacts/3aiiq1gf_IMG_5386.jpeg",
    caption: "Low key · practicals only",
    aspect: "aspect-square",
  },
  {
    id: "bts-6",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/bmbkxcdo_Still%202026-03-11%20211107_1.17.1.webp",
    caption: "\u201CShadows\u201D · Roll A001 · Scene 1F · Take 1",
    aspect: "aspect-[21/9]",
  },
  {
    id: "bts-7",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/i70zm53r_att.Ffj7yUQk7y65I6jlxLfjf8VJ1MTB19PGrKR7WhyQSBE.webp",
    caption: "Steadicam · haze pass through the gym",
    aspect: "aspect-[3/4]",
  },
  {
    id: "bts-8",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/y7vmp33c_imagejpeg_2%206.jpeg",
    caption: "Overhead rig · ladder pre-light",
    aspect: "aspect-[16/9]",
  },
  {
    id: "bts-9",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/yvvz96y4_imagejpeg_2.jpeg",
    caption: "Camera prep · locker 6",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-10",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/vwkhsjn4_imagejpeg_3.jpeg",
    caption: "Locker room · key from stage right",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-11",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/c7e85q3v_IMG_5382.jpeg",
    caption: "Director briefing cast · backlit haze",
    aspect: "aspect-[4/5]",
  },
  {
    id: "bts-12",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/5onarngq_TLK_SD01_260524-32.webp",
    caption: "\u201CThe Little Knight\u201D · A001 · Scene 1A · Take 2",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-13",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/de1tpir5_TLK_SD01_260524-50.webp",
    caption: "Little Knight & the snail · in-camera macro",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-14",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/spcl4c8t_TLK_SD01_260524-11.webp",
    caption: "Dressing the foreground · practical grass",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-15",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/j1ftvg66_TLK_SD01_260524-31.webp",
    caption: "Director + Producer + DP · script review",
    aspect: "aspect-[3/2]",
  },
  {
    id: "bts-16",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/9yqlbyp8_TLK_SD01_260524-33.webp",
    caption: "Village monitor · through the operator",
    aspect: "aspect-[3/2]",
  },
];

export const stats = [
  { value: "70+", label: "Projects shipped" },
  { value: "12", label: "Festival selections" },
  { value: "8", label: "Years on set" },
  { value: "4", label: "Continents shot" },
];

export const credits = [
  { year: "2025", title: "Missy: F*ck Marry Kill", role: "Cinematographer", format: "Music Video" },
  { year: "2025", title: "Missy: Boss", role: "Cinematographer", format: "Music Video" },
  { year: "2024", title: "Little Knight", role: "Director of Photography", format: "Short" },
  { year: "2024", title: "Illuminati Castrati", role: "Cinematographer", format: "Short" },
  { year: "2024", title: "Shadows", role: "Director of Photography", format: "Short" },
  { year: "2023", title: "Good Men", role: "Cinematographer", format: "Short" },
  { year: "2023", title: "Love is Dead", role: "Cinematographer", format: "Short" },
  { year: "2023", title: "Hudson Hemisphere", role: "Gaffer", format: "Short" },
  { year: "2022", title: "The New Rich Family Grudge", role: "Cinematographer", format: "TV Mini Series" },
  { year: "2022", title: "The Volcano: Rescue from Whakaari", role: "Lighting · NZ Unit", format: "Feature" },
  { year: "2022", title: "Sui Generis", role: "Gaffer · Best Boy", format: "TV Series" },
  { year: "2021", title: "Shadows", role: "Cinematographer", format: "Short" },
  { year: "2021", title: "My Life Is Murder", role: "Lighting", format: "TV Series" },
  { year: "2019", title: "The Waiting Room", role: "Cinematographer", format: "Short" },
  { year: "2019", title: "Treasure", role: "Cinematographer", format: "Short" },
  { year: "2018", title: "Between the Parallel", role: "Cinematographer", format: "Short" },
  { year: "2017", title: "Stay", role: "Cinematographer", format: "Short" },
  { year: "2016", title: "Duck Duck Goose", role: "Cinematographer", format: "Short" },
  { year: "2016", title: "Loss", role: "Cinematographer", format: "Short" },
  { year: "2016", title: "Distraction", role: "Cinematographer", format: "Short" },
  { year: "2015", title: "Abandoned", role: "Camera Dept · Focus Puller", format: "Feature" },
  { year: "2014", title: "Housebound", role: "Lighting Technician", format: "Feature" },
];

export const imdbUrl = "https://www.imdb.com/name/nm4815775/";

export const stills = [
  {
    id: "still-1",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/0aegciw3_Still%202026-03-27%20203217_1.19.1.jpeg",
    caption: "Diner · two-shot · practical window",
  },
  {
    id: "still-2",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/riyhzlv9_Still%202026-03-27%20203217_1.13.3.jpeg",
    caption: "Hooded · medium · direct look",
  },
  {
    id: "still-3",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/mq104tv2_Still%202026-03-27%20203217_1.27.1.jpeg",
    caption: "Phone call · single · tungsten glow",
  },
  {
    id: "still-4",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/a35fsgvy_Still%202026-03-27%20203217_1.13.2.jpeg",
    caption: "OTS · foreground defocus",
  },
  {
    id: "still-5",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/00tik2kp_Still%202026-03-27%20203217_1.16.1.jpeg",
    caption: "Close · low key · window fill",
  },
  {
    id: "still-6",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/qjty38mu_Still%202026-07-20%20181154_1.146.1.jpeg",
    caption: "Elder · portrait · window backlight",
  },
  {
    id: "still-7",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/48udhgst_Still%202026-07-20%20181154_1.98.1.jpeg",
    caption: "Kitchen · lace curtain · low angle",
  },
  {
    id: "still-8",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/j7lljnv7_Still%202026-07-20%20181154_1.139.2.jpeg",
    caption: "Ring box · foreground detail",
  },
  {
    id: "still-9",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/arzj64as_Still%202026-07-20%20181154_1.11.1.jpeg",
    caption: "Walkway · silhouette in flare",
  },
  {
    id: "still-10",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/tv8ivzph_Still%202026-07-20%20181154_1.3.1.jpeg",
    caption: "Bus window · reflection portrait",
  },
  {
    id: "still-11",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/q5fkbaa9_Still%202026-03-19%20210900_1.35.2.jpeg",
    caption: "Rain window · portrait · golden hour",
  },
  {
    id: "still-12",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/3h3enej3_Still%202026-03-11%20211107_1.17.2.webp",
    caption: "Ring · Snells Beach · haze &amp; overhead",
  },
  {
    id: "still-13",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/p9qm5y23_00540f4a-9f16-406b-a90e-1832d15fe25d.jpeg",
    caption: "Portrait · magic-hour sky",
  },
  {
    id: "still-14",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/bx236lpe_43768ec7-d8e8-48f2-9318-83af531040f0.jpeg",
    caption: "Beach · two-shot · dusk",
  },
  {
    id: "still-15",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/g75868st_26491558-1f12-48a6-81fe-d3ec508e1c3f.jpeg",
    caption: "Hilltop · sea vista · natural light",
  },
  {
    id: "still-16",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/42cjzuao_Still%202025-09-25%20090011_1.78.1.webp",
    caption: "Candlelight · hallway · period",
  },
  {
    id: "still-17",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/3s96g99g_Still%202025-09-23%20071445_1.34.1.webp",
    caption: "Scullery · wide · daylight interior",
  },
  {
    id: "still-18",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/e5vaz1sd_Still%202025-09-23%20071445_1.38.2.webp",
    caption: "Breakfast · single · period portrait",
  },
  {
    id: "still-19",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/j6su5tc1_Still%202025-09-23%20071445_1.41.1.webp",
    caption: "Close · dramatic · low key",
  },
  {
    id: "still-20",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/3mrghcg8_Still%202025-09-23%20123110_1.57.1.webp",
    caption: "Portrait · moonlit window · blue",
  },
  {
    id: "still-21",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/3ya4kjes_Still%202025-06-11%20095405_1.42.1.jpeg",
    caption: "Little Knight · macro portrait",
  },
  {
    id: "still-22",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/luiaws9c_Still%202025-06-11%20095405_1.43.1.jpeg",
    caption: "Little Knight · wide · grass world",
  },
  {
    id: "still-23",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/jn2nlu2d_Still%202025-06-11%20095405_1.44.1.jpeg",
    caption: "Aviator snail · in-camera macro",
  },
  {
    id: "still-24",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/g3njemr9_Still%202025-06-23%20135934_2.1.1.jpeg",
    caption: "Queen · black limbo · single source",
  },
  {
    id: "still-25",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/uizgjj4p_Still%202025-06-19%20184937_1.1.1.jpeg",
    caption: "Chaise · high key on black",
  },
  {
    id: "still-26",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/ounvjqrm_Still%202025-04-06%20231520_1.33.1.webp",
    caption: "Bush · portrait · natural light",
  },
  {
    id: "still-27",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/n0v15zba_Still%202025-04-06%20231520_1.41.1.webp",
    caption: "Walking beam · foreground legs",
  },
  {
    id: "still-28",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/8u67y258_Still%202025-04-06%20231520_1.35.1.webp",
    caption: "Cigarette close &middot; freckles &middot; overcast",
  },
  {
    id: "still-29",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/isg6i5ke_Still%202025-04-06%20231520_2.10.3.webp",
    caption: "Two-shot &middot; log &middot; low angle",
  },
  {
    id: "still-30",
    src: "https://customer-assets-agu9un31.emergentagent.net/job_video-showcase-354/artifacts/akpudwhy_Still%202025-04-06%20231520_2.11.2.webp",
    caption: "Looking up &middot; smoke &middot; sky",
  },
];
